import { grey } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
	0% { opacity: 0.55; }
	50% { opacity: 1; }
	100% { opacity: 0.55; }
`

export const SkeletonBody = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 12px;
	min-height: 72px;
`

export const SkeletonBlock = styled.span<{ $height?: number; $width?: string }>`
	display: block;
	height: ${({ $height }) => $height ?? 14}px;
	width: ${({ $width }) => $width ?? '100%'};
	border-radius: ${radii.inner};
	background: ${grey};
	animation: ${shimmer} 1.2s ease-in-out infinite;
`
